import { GetEcshopTradesApi } from "@/features/accounts/ecshop/services/get-trades-api";
import { GetEcshopTradesRequestModel } from "@/features/accounts/ecshop/services/get-trades-model";

/// その他連携明細一覧取得処理
export class GetEcshopTradesService {
  private getEcshopTradesApi = new GetEcshopTradesApi();

  /**
   * その他連携明細一覧取得API実行
   */
  public async getEcshopTrades(param: GetEcshopTradesRequestModel) {
    return await this.getEcshopTradesApi.getEcshopTrades(param);
  }
}
